import React from "react"
import { Row, Col, Tabs, Space } from "antd"
import StatCard from "../components/StatCard"
import QuickActions from "../components/QuickActions"
import NotificationPanel from "../components/NotificationPanel"
import BankTransactions from "../components/BankTransactions"
import {
  ProjectOutlined,
  CheckCircleOutlined,
  ClockCircleOutlined,
  FileAddOutlined,
  AppstoreOutlined,
  FolderOutlined,
  BarChartOutlined,
  BankOutlined,
} from "@ant-design/icons"

const GasCoDashboard = ({
  infoMessage,
  telegramLink,
  userInfo,
}) => {
  // Mock stats - replace with actual data from props
  const stats = [

  ]

  // Tab items using modern Ant Design API
  const tabItems = [
    {
      key: "1",
      label: (
        <Space>
          <AppstoreOutlined />
          نمای کلی
        </Space>
      ),
      children: (
        <Row gutter={[16, 16]}>
          <Col xs={24} lg={8}>
            <QuickActions role="Nezarat" />
          </Col>
          <Col xs={24} lg={16}>
            <NotificationPanel
              telegramLink={telegramLink}
              showTelegram={true}
              maxItems={5}
            />
          </Col>
        </Row>
      ),
    },
  ]

  return (
    <Space direction="vertical" size="large" style={{ width: "100%" }}>
      {/* Statistics Cards */}
      <Row gutter={[16, 16]}>
        {stats.map((stat, index) => (
          <Col xs={24} sm={12} lg={6} key={index}>
            <StatCard {...stat} />
          </Col>
        ))}
      </Row>

      {/* Main Content */}
      <Tabs
        defaultActiveKey="1"
        size="large"
        type="card"
        items={tabItems}
        destroyInactiveTabPane={true}
      />
    </Space>
  )
}

export default GasCoDashboard
